// extracted by mini-css-extract-plugin
module.exports = {"main-component":"circleTick_main-component__1_LEq"};